import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicalCross: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="medical-cross, first-aid, emergency"><path d="M13.25 2C14.7688 2 16 3.23122 16 4.75V6.75C16 7.44036 16.5596 8 17.25 8H19.25C20.7688 8 22 9.23122 22 10.75V13.25C22 14.7688 20.7688 16 19.25 16H17.25C16.5596 16 16 16.5596 16 17.25V19.25C16 20.7688 14.7688 22 13.25 22H10.75C9.23122 22 8 20.7688 8 19.25V17.25C8 16.5596 7.44036 16 6.75 16H4.75C3.23122 16 2 14.7688 2 13.25V10.75C2 9.23122 3.23122 8 4.75 8H6.75C7.44036 8 8 7.44036 8 6.75V4.75C8 3.23122 9.23122 2 10.75 2H13.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMedicalCross;
